import { withSession } from '@zipdrug/react-api-sdk';
import pharmacyTypes from 'dashboard/components/LeadList/constants/pharmacyServiceTypes';
import GET_PHARMACY_SERVICE_TYPES from 'dashboard/components/LeadList/graphql/getPharmacyServiceTypes';
import { get } from 'lodash';
import { graphql } from 'react-apollo';
import React from 'react';
import fetchOnceOptions from './utils/fetchOnceOptions';
import withSelectedPatientId from './withSelectedPatientId';

const withPharmacyServiceTypes = Component =>
  graphql(GET_PHARMACY_SERVICE_TYPES, {
    skip: ({ selectedPatientId }) => !selectedPatientId,
    options: () =>
      fetchOnceOptions('pharmacyServiceType', {
        variables: {
          query: {
            pharmacy_service_type: Object.values(pharmacyTypes),
          },
        },
      }),
    props: ({ data: { pharmacyServiceType: result } }) => ({
      serviceTypes: get(result, 'data'),
    }),
  })(Component);

export default Component => {
  // Wrapper component to replace mapProps
  const ServiceTypesMapper = (props) => {
    const { serviceTypes, ...restProps } = props;
    
    return <Component serviceTypes={serviceTypes} {...restProps} />;
  };

  // Manual HOC composition (previously done by compose)
  const ServiceTypesEnhanced = withPharmacyServiceTypes(ServiceTypesMapper);
  const SessionEnhanced = withSession(withSelectedPatientId(ServiceTypesEnhanced));
  
  return SessionEnhanced;
};
